<template>
    <div v-if="step > 1" class="mobile-shadow bg-white pb-2 mobile-fixed-bottom mt-3">
        <div class="d-none d-lg-block">
            <label v-if="step === 2" class="mb-0">
                <strong>{{ trans('general.module.report.update_popup.note') }}:</strong>
                {{ trans('general.module.report.update_popup.step.apply_to.note') }}
            </label>
            <label v-if="step === 3" class="mb-0">
                <strong>{{ trans('general.module.report.update_popup.note') }}:</strong>
                {{ trans('general.module.report.update_popup.step.details.note') }}
            </label>
        </div>
        <div class="back-next-btns d-flex align-items-center gap-3 mt-2 mt-lg-0 px-3 w-100 justify-content-between">
            <basic-button
                :disabled="prevDisabled"
                @click="go('back')"
                icon="fi-rr-arrow-left"
                :text="trans('general.defaults.back')"
                class="btn text-gray-600"/>

            <basic-button
                :loading="step === 3 && nextDisabled"
                :disabled="nextDisabled"
                @click="go('next')"
                :icon="step === 3 ? 'fi-rr-check' : 'fi-rr-arrow-right'"
                icon-position="right"
                :text="step === 3 ? trans('general.defaults.finish') : trans('general.defaults.next')"
                :class="step === 3 ? 'btn-success' : 'btn-outline'"/>
        </div>
    </div>
</template>

<script>
import BasicButton from "../../../theme/atoms/BasicButton.vue";

export default {
    name: "ReportFooter",
    components: {
        BasicButton
    },
    props: {
        step: {
            type: Number,
            required: false
        },
        prevDisabled: {
            type: Boolean,
            required: false
        },
        nextDisabled: {
            type: Boolean,
            required: false
        }
    },
    methods: {
        go(direction) {
            this.$emit('change-step', direction);
        },
    }
}
</script>
